import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { not_found, organizationProfileDefault } from "../../../App/GlobaleVariables"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { RootState } from "../../../App/store"
import Header from "../Header/Header"
import DonateButton from "../Components/DonateButton"
import Footer from "../Layout/Footer"
import MainLayout from "../Layout/MainLayout"
import OrganizationProfileCard from "../Components/OrganizationProfileCard"
import ModalGroup from "../Components/ModalGroup"
import RoomDropdown from "../Components/RoomDropdown"
import SponsorCard from "../Components/SponsorCard"
import { LoadingAnimation, SearchIcon } from "../Components/SvgIcons"
import UserCard from "../Components/UserCard"
import { setNewOrganizationsData } from "../SharedSlices/NewestMembersSlice"
import { useNavigate, useParams } from "react-router"
import { newestOrganizationsGetRequest } from "./NewestOrganizations"
import NewestMembersCard from "../NewestMembers/NewestMemberCard"
import { RoleType } from "../../../App/enums"
import IndividualProfileCard from "../Components/IndividualProfileCard"
import BackgroundWrapper from "../Components/BackgroundWrapper"
import { onHashtagClick } from "../Hashtag/onHashtagClick"

function NewestOrganizationsScreen() {
    const translation = useSelector(selectTranslations)
    const newOrganizationsState = useSelector((state: RootState) => state.newMembers.newOrganizationsSlice.organizations)
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(true)
    const organizationDataState = useSelector((state: RootState) => state.organizationsSlice.organizationSlice.organization)
    const donationLink = useSelector((state: RootState) => state.UserSettingsStatusSlice.userDonationLinkSlice.link)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const navigate = useNavigate()
    const { id } = useParams()

    const onSeeAllEventsClick = () => {
        switch (role) {
            case RoleType.ORGANIZATION:
                navigate(`/all-premium-events/${id}`)
                break
            case RoleType.USER:
                navigate(`/all-premium-events`)
                break
            default:
                break
        }
    }

    useEffect(() => {
        let isMounted = true

        newestOrganizationsGetRequest()
            .then(response => {
                if (isMounted && response.status === 200) {
                    dispatch(setNewOrganizationsData(response.data))
                    setIsLoading(false)
                }
            })
            .catch(error => {
                console.log(error)
            })
        return () => {
            isMounted = false
        }
    }, [dispatch])

    const onNavigationToOrganizationProfile = (organizationId: number) => {
        switch (role) {
            case RoleType.USER:
                const userPath = `/organization-profile/${organizationId}`
                navigate(userPath)
                window.scrollTo(0, 0)
                break
            case RoleType.ORGANIZATION:
                const organizationPath = `/organization-profile/${id}/${organizationId}`
                navigate(organizationPath)
                window.scrollTo(0, 0)
                break
            default:
                break
        }
    }

    const organizations = newOrganizationsState.filter(organization => {
        return organization.id !== organizationDataState.id
    })

    return (
        <BackgroundWrapper>
            <Header />
            <MainLayout
                leftPanelFirstComponent={role === RoleType.USER ? <OrganizationProfileCard /> : <IndividualProfileCard />}
                leftPanelSecondComponent={<RoomDropdown type={role!} />}
                RightPanelFirstComponent={role === RoleType.USER ? donationLink === not_found ? <DonateButton /> : null : null}
                RightPanelSecondComponent={translation.newsMembersText}
                RightPanelThirdComponent={<NewestMembersCard />}
                RightPanelForthComponent={
                    <div className="main-layout__sponsored-title">
                        {translation.sponsoredText}
                        <div onClick={onSeeAllEventsClick} className="main-layout__sponsored-icon">
                            <SearchIcon color="dark-blue" />
                        </div>
                    </div>
                }
                RightPanelFifthComponent={<SponsorCard />}
                overflowModifier={true}
            >
                <div className="newest-members-screen">
                    <div className="newest-members-screen__title">{translation.newestOrganizations}</div>
                    <div className="newest-members-screen__card">
                        <div className="newest-members-screen__content">
                            {isLoading ? (
                                <div className="newest-members-screen__loading">
                                    <LoadingAnimation />
                                </div>
                            ) : (
                                organizations?.map(item => {
                                    return (
                                        <div key={item.id}>
                                            <UserCard
                                                onTextClick={() => onNavigationToOrganizationProfile(item.id)}
                                                onLeftItemClick={() => onNavigationToOrganizationProfile(item.id)}
                                                imageSrc={item.photo?.url_path || organizationProfileDefault}
                                                text={item.name}
                                                rightText=""
                                                subtext={
                                                    <div className="profile-header__tags-content profile-header__tags-content--width-99">
                                                        {item.hashtags?.map((hashtag, index) => (
                                                            <p
                                                                className="profile-header__tag"
                                                                key={index}
                                                                onClick={() => onHashtagClick(hashtag, navigate, role, parseInt(id!))}
                                                            >
                                                                {hashtag.charAt(0) !== "#" ? "#" + hashtag : hashtag}
                                                            </p>
                                                        ))}
                                                    </div>
                                                }
                                                userCardStyle={"newest-members-expanded-item"}
                                                leftPanelStyle={"left-panel"}
                                                middlePanelStyle={"middle-panel"}
                                                rightPanelStyle={""}
                                                profileImageStyle={"image image__profile image__profile--fit image__profile--size-medium-small"}
                                                textStyle={"text"}
                                                textStyleMore25={"text"}
                                                subtextStyle={"subtext"}
                                                rightTextStyle={"right-text"}
                                                textStyleContainer={"text-container"}
                                                subtextStyleContainer={"subtext-container"}
                                            />
                                        </div>
                                    )
                                })
                            )}
                        </div>
                    </div>
                </div>
            </MainLayout>
            <Footer />
            <ModalGroup />
        </BackgroundWrapper>
    )
}

export default NewestOrganizationsScreen
